import {Client} from "../../api/api";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {setter} from "../utils/setter";
import _ from "lodash";

export interface ClientsState {
  list?: Client[],
  selectedClients?: number
}

const initialState: ClientsState = {}

export const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setList: setter(initialState, 'list'),
    addList: (s: ClientsState, a: PayloadAction<Client[]|undefined>) => {
      if (!a.payload) return;
      const list = s.list || []
      s.list = _.uniqBy([...list, ...a.payload], row => row.id)
    },
    addClient: (s: ClientsState, a: PayloadAction<Client>) => {
      const list = _.filter(s.list, c => c.id !== a.payload.id)
      s.list = _.sortBy([...list, a.payload], 'id')
    },
    selectClient: setter(initialState, 'selectedClients')
  }
})
